"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Theme_1 = __importDefault(require("../../Theme"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const useStyles = styles_1.makeStyles(() => styles_1.createStyles({
    modal: {
        height: "80vw",
        alignItems: "center",
        padding: Theme_1.default.spacing(5),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    modalText: {
        fontWeight: "bold",
        lineHeight: "200%",
        textAlign: "center",
    },
    modalCloseButton: {
        color: Theme_1.default.palette.background.default,
        backgroundColor: Theme_1.default.palette.primary.main,
        width: "100%",
        alignSelf: "flex-end",
    },
}));
const InfoModal = (props) => {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Dialog, { open: props.open, disableBackdropClick: true },
        react_1.default.createElement(core_1.DialogContent, { className: classes.modal },
            react_1.default.createElement(core_1.Box, { display: "flex", height: "100%", alignItems: props.isCenteredMessage ? "center" : undefined },
                react_1.default.createElement(core_1.Typography, { "data-testid": "info-modal-message", className: classes.modalText }, props.message)),
            react_1.default.createElement(core_1.Button, { "data-testid": "close-modal-button", id: "close-modal-button", onClick: props.onClose, className: classes.modalCloseButton },
                react_1.default.createElement(core_1.Typography, null, props.closeButtonText)))));
};
exports.default = InfoModal;
//# sourceMappingURL=index.js.map